<template>
<!-- 省市区 -->
    <div class="left-menu" ref="leftMenu" style="overflow:auto;">
        <!-- 舆情分析 -->
        <div class="inside" v-if="$route.meta.pageType === 0">
            <div class="left-fang">
                <div class="btn-warp clearfix">
                    <router-link class="fl"  v-if="userInfo.isAdmin" :to="{path:'/analysis/buildSolution'}"><button class="btn build btn-jbblue"><i class="icons add-icon"></i>新建</button></router-link>
                    <!-- <button class="btn switch btn-border-blue fr" @click="selectPlan();">切换方案</button> -->
                </div>
                <div class="text clearfix" v-if="$parent.isPlan!= ''">
                    <div v-for="(item,index) in planList" :key="index" class="planlist" @click="enterPlan(item.id,item.name);" :class="$parent.isPlan.id == item.id?'pactive':''">
                        <span v-if="userInfo.isAdmin" class="planchild">
                            <a class="href fr" href="javascript:void(0);" @click.stop="delPlan(item.id);" title="删除方案"><i class="icons del-sm-icon"></i></a>
                            <a class="href fr" href="javascript:void(0);" @click.stop="editPlan(item.id);" title="编辑方案"><i class="icons edit-icon3"></i></a>
                            <a class="href fr" href="javascript:void(0);" @click.stop="openKeywordsMatching(item.id);" title="选择查看范围"><i class="icons select-icon"></i></a>
                        </span>
                        <span class="ovhidden db">{{item.name}}</span>
                    </div>
                </div>
            </div>   
        </div>
        <!-- 个人中心 -->
        <div class="inside" v-if="$route.meta.pageType === 4">
            <div class="personal-rank color-8a8a99">
                <img class="img db" :src="$parent.headImg === '' ? 'static/images/headImg.png' : $parent.headImg" onerror="this.src='static/images/headImg.png'"/>
                <div class="user-name mt20 ac">{{$parent.nickname}}</div>
                <!-- <div class="rank ac"><i class="icons" :class="vipIcons[$parent.memberType-1]" v-if="$parent.memberType != 0"></i>{{$parent.memberTypeName}}</div> -->
                <div class="rank ac"><span class="color-white">{{$parent.expireTime}}到期</span></div>
                <!-- <div class="rank ac">剩余短信数：<span class="color-white">{{$parent.remainSmsNum}}</span> 条</div> -->
                <!-- <div class="rank ac">剩余下载量：<span class="color-white">{{$parent.remainDownloadNum}}</span> 条</div> -->
            </div>
            <ul class="naver">
                <li v-for="(item,index) in $parent.company.config.upperRightMenus" :key="index">
                    <router-link v-if="item.type ===2" class="db" :class="$route.meta.shuYu === 'vip'&&index ===0 ? 'router-link-active' : ''" :to='item.url'><i class="icons fl" :class="item.icon"></i>{{item.menuName}}</router-link>
                </li>
            </ul>
        </div>
        <!-- 热点事件 -->
        <div class="inside mt20" v-if="$route.meta.pageType === 2">
            <ul class="naver">
                <li>
                    <router-link class="db" to='/eventsIndex'><i class="icons nav-icon9 fl"></i>事件首页</router-link>
                </li>
                <li>
                    <router-link class="db" to='/eventsKu'><i class="icons nav-icon10 fl"></i>事件库</router-link>
                </li>
                <!-- <li>
                    <router-link class="db" to='/specialKu' :class="$route.meta.shuYu === 'eventSpecia' ? 'router-link-active' : ''"><i class="icons nav-icon11 fl"></i>专题库</router-link>
                </li> -->
            </ul>
        </div>
        <!-- 信息汇总全部 -->
        <div class="inside" v-if="$route.meta.pageType === 6">
            <h3 class="bt color-blue">方案列表</h3>
            <ul class="menus">
                <li class="li" v-for="(item,index) in planShowList" :key="index">
                    <strong class="title color-blue">{{item.typeName}}</strong>
                    <div>
                        <a v-for="(items,indexs) in item.schemeList" :style="{color:sid===items.id?'#0095eb':'#fff'}" class="link ovhidden" href="javascript:void(0);" :key="indexs" @click="selectEnterPlan(items.id);">{{items.name}}</a>
                    </div>
                </li>
            </ul>    
        </div>
        <!-- 选择方案 -->
        <Dialog ref="planModal" type="normal" width="776" title="选择方案" :modalFoot="false">
            <div slot="mdBox">
                <vue-scroll :ops="ops" style="width:100%;height:420px">
                    <div class="search-warp clearfix">
                        <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                        <div class="hidden"><input class="input-text" v-model="searchQuery" type="text" placeholder="请输入方案名称进行搜索"/></div>
                    </div>
                    <div class="plan-list mt20">
                        <div class="item" v-for="(item,index) in planShowList" :key="index">
                            <p class="title">
                                <strong class="tion">{{item.typeName}}</strong>
                                <a class="icons edit-icon1 tion" href="javascript:void(0);"  v-if="userInfo.isAdmin" @click="editPlanClassification(index);"></a>
								<a class="icons del-sm-icon tion" href="javascript:void(0);" v-if="userInfo.isAdmin" @click="delPlanClassification(index,item.typeId);"></a>
                            </p>
                            <ul class="plan-ul clearfix">
                                <li v-for="(items,index) in item.schemeList" :key="index" :class="items.id === $parent.isPlan.id ? 'curr' : ''" @click="enterPlan(items.id,items.name);">
                                    <div class="caozu fr">
                                        <a class="icons edit-icon1" href="javascript:void(0);" v-if="userInfo.isAdmin" @click.stop="editPlan(items.id);"></a>
                                        <a class="icons del-sm-icon" href="javascript:void(0);" v-if="userInfo.isAdmin" @click.stop="delPlan(items.id);"></a>
                                    </div>
                                    <span class="name ovhidden">{{items.name}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </vue-scroll>
            </div>
        </Dialog>
         <!-- 删除提示 -->
        <Dialog ref="delPlanModal" :callback="enterDelPlan" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否删除此方案</p>
            </div>
        </Dialog>
        <!-- 当前方案关键词选择 -->
		<Dialog ref="keywordsMatch" title="选择关键词" :callback="keywordsMatching" type="normal" width="600">
			<div slot="mdBox" style="max-height:500px;overflow:auto">
				<div class="checkbox-group nolike clearfix" v-if="keywordsMain&&keywordsMain.length>0">
                    <p style="clear:both;height:30px;line-height:30px;width:500px;">主体词：</p>
					<label class="checkbox-box" v-for="(item,index) in keywordsMain" :key="index">
						<label class="checkbox-warp fl" :class="keywordsMainSelect.indexOf(item) != -1 ? 'curr' : ''"><input name="" v-model="keywordsMainSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i></label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
                <div class="checkbox-group nolike clearfix" v-if="keywordFinal&&keywordFinal.length>0">
                    <p style="clear:both;height:30px;line-height:30px;width:500px;margin-top:10px;">分析词：</p>
					<label class="checkbox-box" v-for="(item,index) in keywordFinal" :key="index">
						<label class="checkbox-warp fl" :class="keywordSelect.indexOf(item) != -1 ? 'curr' : ''"><input name="" v-model="keywordSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i></label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
			</div>
		</Dialog>
    </div>
</template>
<script>
import Dialog from './dialog.vue';
import {mapState} from 'vuex';
export default {
    components:{Dialog},
    computed:{
        ...mapState({
            userInfo: state => state.user.userInfo,
        })
    },
    name: "left",
    props: {
        name:{
            type: [String],
            default: '',
        }
    },
    data() {
        return {
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            searchQuery:'',//方案关键词搜索
            planNameType:'',
            delId:'',//方案删除的ID
            pageType:2, //0是舆情分析 1是产品市场 2是热点事件 3是帮助文档 4是个人中心
            vipIcons:['rank-icon3','rank-icon1','rank-icon3','rank-icon5'],//会员等级对照表
            planList:[],//方案列表
            planShowList:[],//方案显示列表
            delReptId:'',//竞对方案删除的ID
            opsHeight:'',
            keywordSelect:[],//方案关键词选择
            isCreatePlan:false,//判断点击的竞对方案是否改变
            keywordsMainSelect:[],//方案主体词选择
            keywordFinal:[],//方案关键词
            keywordsMain:[],//方案主体词
            planId:''
        }
    },
    mounted() {
        let that = this;
        that.opsHeight = that.$refs.leftMenu.offsetHeight-81;
        that.getPlanList();
    },
    methods: {
        // 获取方案列表
        getPlanList () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据');
            that.$api.get('monitor/scheme/list',null,r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.planList = r.data;
                });           
            })
        },
        // 选择方案
        selectPlan () {
            let that = this;
            that.getPlanList();
        },
        // 确定方案
        enterPlan (id,name,from) {
            let that = this;
            let value = {
                id:id, 
                name:name
            };
            that.$api.get('monitor/scheme/change',{id:id},r =>{
                that.$utils.returnCode(r,function(){
                    that.planList = r.data; 
                    that.$refs.planModal.closeMask();
                    that.resetSetItem('planStorage', JSON.stringify(value));
                    if(from){
                        //that.$parent.getCurrplan('/analysis/informationSet');
                    }else{
                        if(that.$route.path === '/analysis/buildSolution'){
                            that.$router.push({path:'/analysis/buildSolution',query:{planId:id}});
                            window.location.reload();
                        }else{
                            window.location.reload();
                        }
                    }
                });           
            })
        },
        //方案信息汇总切换
        selectEnterPlan(id){
            this.$store.dispatch('allInformationSet/changeSid',{sid:id})
        },
        // 删除方案
        delPlan (id) {
            let that = this;
            that.delId = id;
            that.$refs.delPlanModal.showMaskFun();
        },
        // 确认删除
        enterDelPlan () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/scheme/delete',{id:that.delId},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功');
                    if(that.$parent.isPlan.id == that.delId){//删除的方案是当前方案会刷新页面
                        location.reload();
                        return;
                    }
                    if(r.data.length === 0){//方案全部删除完
                        that.$parent.getCurrplan();
                        that.$refs.planModal.closeMask();
                        return;
                    }
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    that.$refs.delPlanModal.closeMask();
                    that.$refs.planModal.showMaskFun();
                });           
            })
        },
        // 删除方案分类
		delPlanClassification (index,id){
			let that = this;
			let list = that.planShowList;
			let len = list[index].schemeList.length;
			if(len > 0){
				that.$utils.alertText('此分类包含方案，不能删除！');
				return;
			}
			that.$confirm('是否删除此分类？').then(() => {
				let data = {
					id:id
				}
				that.$parent.loadModal(true,'正在删除...');
				that.$api.post('monitor/scheme-type/del',{data:data},r =>{
					that.$parent.showLoad = false;
					that.$utils.returnCode(r,function(){
						that.$utils.alertText('删除成功！');
						list.splice(index,1);
					})
				})
			})
        },
        // 打开方案多个关键词组的匹配信息弹框
        openKeywordsMatching(id){
            let that = this;
            this.planId = id;
            that.$api.get('monitor/scheme/select-range',{sid:id},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.keywordSelect = [...r.data.keywordSelect];
                    that.keywordFinal = [...r.data.keywordFinal];
                    that.keywordsMain = [...r.data.keywordsMain];
                    that.keywordsMainSelect = [...r.data.keywordsMainSelect];
                    that.$refs.keywordsMatch.showMaskFun();
                });           
            })   
        },
        // 方案多个关键词组的匹配信息
        keywordsMatching () {
            let that = this;
            if(that.keywordSelect.length <= 0&&that.keywordsMainSelect.length <= 0){
                that.$utils.alertText('请选择关键词或主体词');
                return;
            }
            that.$parent.loadModal(true,'正在提交数据...');
            let datas = {
                sid:that.planId,
                keywordsSelect:that.keywordSelect,
                keywordsMainSelect:that.keywordsMainSelect
            }
            that.$api.post('monitor/scheme/keywords-select',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('设置成功');
                    location.reload();
                });           
            })
        },
        // 修改方案
        editPlan (id) {
            this.$refs.planModal.closeMask();
            this.$router.push({ path:'/analysis/buildSolution',query:{planId:id}})
        },
        // 搜索方案
        searchPlan (val) {
            let that = this;
            if(val == ''){
                that.planShowList = that.planList;
            }else{
                let planList = that.planList;
                let schemeList = [];
                for(let i of planList){
                    let num = 0;
                    let arr1 = [];
                    for(let j of i.schemeList){
                        num++;
                        let name = j.name;
                        if(name.indexOf(val) != -1){
                            if(num === 1){
                                
                            }
                            arr1.push(j)
                        }
                        
                    }
                    if(arr1 != ''){
                        schemeList.push({
                            'typeName':i.typeName,
                            'schemeList':arr1
                        })
                    }
                }
                that.planShowList = schemeList;
            }
        }
    },
    watch: {
        searchQuery (val) {
            this.searchPlan(val);    
        },
        name:{
            handler(){
                this.getPlanList();
            },deep:true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/left.vue